import {Component, inject, Inject, OnInit, TemplateRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {DepartmentService, OrganizationService, ReferenceService,} from '../../../apiModule1';
import {map} from 'rxjs/operators';
import {CommunicationService} from '../../../../core/services/communication.service';


@Component({
  selector: 'pas-dialog-users',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton,
    MatButton,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,

  ],
})
export class DialogComponent implements OnInit {

  isNew: boolean = false;

  toastService = inject(CommunicationService);
  referenceService: ReferenceService = inject(ReferenceService);
  roles: Role[] = [];
  currentRole: Role | null = null;

  content: TemplateRef<any> | null = null;
  organizations: Organization[] = [];
  departments: Department[] = [];


  mainForm: FormGroup = new FormGroup({
    organization: new FormControl<Organization>(this.data['organization'] || {}),
    department: new FormControl<Organization>(this.data['department'] || {}),
    position: new FormControl<string>(''),
    fio: new FormControl<string>('', [Validators.required]),
    email: new FormControl<string>('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
    login: new FormControl<string>('', [Validators.required]),
    password: new FormControl<string>('', [Validators.required]),
  })
  isEnabled: boolean = false;

  get formControls() {
    return this.mainForm.controls;
  }


  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    public organizationService: OrganizationService,
    public departmentService: DepartmentService,
  ) {
    this.isNew = data['isNew'];
    console.log('data', data);

    this.organizationService.apiOrganizationGet({pageIndex:0}).pipe(map(v => v.values)).subscribe((v: Organization[]) => {
      this.organizations = v;
      const foundOrganization = this.organizations.find(v => v.id === this.data['organization']?.id);
      if (foundOrganization) {
        this.mainForm.get('organization')!.setValue(foundOrganization);
      }
    })

    this.departmentService.apiDepartmentGet({pageIndex:0}).pipe(map(v => v.values)).subscribe((v: Department[]) => {
      this.departments = v;
      const foundDepartment = this.departments.find(v => v.id === this.data['departments']?.id);
      if (foundDepartment) {
        this.mainForm.get('organization')!.setValue(foundDepartment);
      }
    })

    this.referenceService.apiReferenceRolesGet()
      .pipe(map(v => v.values))
      .subscribe((v: Role[]) => {
        this.roles = v;
      });

    console.log('isNew', this.isNew, this.data);

    if (!this.isNew) {
      this.currentRole = this.data['roles'][0];
      this.data['position'] && this.mainForm.get('position')!.setValue(this.data['position']);
      this.data['email'] && this.mainForm.get('email')!.setValue(this.data['email']);
      this.data['phone'] && this.mainForm.get('phone')!.setValue(_phoneMask(this.data['phone'].replace(/[^0-9]/g, '')));
      this.data['userName'] && this.mainForm.get('login')!.setValue(this.data['userName']);
      this.data['password'] && this.mainForm.get('password')!.setValue(this.data['password']);

      this.mainForm.get('fio')!.setValue(this.data['lastName'] + ' ' + this.data['firstName'] + ' ' + this.data['middleName']);

    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onApply() {
    this.mainForm.markAllAsTouched();
    const [lastName, firstName, middleName] = this.mainForm.get('fio')?.value.split(' ')
      .map((v: string) => v.trim()).filter(Boolean);
    if (this.mainForm.invalid) {
      return this.toastService.error('Проверьте правильность заполнения формы');
    }
    const res: User = {
      id: this.data['id'],
      email: this.mainForm.get('email')?.value,
      firstName,
      lastName,
      middleName,
      position: this.mainForm.get('position')?.value,
      phone: this.mainForm.get('phone')?.value,
      userName: this.mainForm.get('login')?.value,
      password: this.mainForm.get('password')?.value,
      organization: this.mainForm.get('organization')?.value,
      department: this.currentRole?.code === 'department' ? this.mainForm.get('department')?.value : null,
      roles: [this.currentRole || {} as Role],
      status: this.data['status'],
      rights: this.data['rights']
    }
    this.dialogRef.close(res);
  }

  ngOnInit() {
    this.mainForm.valueChanges.subscribe((v) => {
      console.log('mainForm', v);
    })
    this.mainForm.get('phone')!.valueChanges.subscribe((v) => {
      this.mainForm.get('phone')!.setValue(_phoneMask(v), {emitEvent: false});
    })
    this.mainForm.get('organization')!.valueChanges.subscribe((v) => {
      console.log('organization', v);
    })
  }

  onOrganizationSelected($event: MatAutocompleteSelectedEvent) {
    console.log($event);
  }
}

export const _phoneMask = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');

    let masked = digits.slice(0, 10)
        .replace(/^(\d)/, '($1')
        .replace(/^(\(\d{3})(\d)/, '$1) $2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})(\d{1,2})$/, '$1-$2');

    if (digits.length > 10) {
        const extension = digits.slice(10);
        masked += ` (доб. ${extension})`;
    }

    return masked;
}
